import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import Button from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { DisplayS, LabelM } from '@sorare/core/src/atoms/typography';
import { useIsMobile } from '@sorare/core/src/hooks/device/useIsMobile';
import { glossary } from '@sorare/core/src/lib/glossary';

import { BaseLayout } from '@sorare/football/src/components/rivals/SquadPromotionRelegationStory/BaseLayout';

import { Stable_footballRivalsSquadPromotionRelegationStory } from './__generated__/index.graphql';

const Root = styled(Vertical).attrs({ center: true })`
  position: relative;
  width: 200px;
  height: 217px;
`;
const SquadImage = styled.img`
  position: absolute;
  z-index: -1;
`;
const DivisionBadge = styled.img`
  width: 120px;
  height: 120px;
  position: absolute;
  bottom: -90px;
  z-index: 1;
`;

type Props = {
  story: Stable_footballRivalsSquadPromotionRelegationStory;
  onDismiss: () => void;
};
export const Stable = ({ story, onDismiss }: Props) => {
  const isMobile = useIsMobile();

  return (
    <BaseLayout
      diamondColor="var(--c-rgb-rivals-purple-600)"
      gridColor="#ad00ff"
      titleColor="var(--c-rivals-purple-600)"
      title={
        <DisplayS>
          <FormattedMessage
            id="SquadPromotionRelegationStory.Stable.title"
            defaultMessage="{ordinal, selectordinal, one {#st} two {#nd} few {#rd} other {#th}} Place"
            values={{ ordinal: story.ranking }}
          />
        </DisplayS>
      }
      subtitle={
        <LabelM color="var(--c-neutral-700)">
          <FormattedMessage
            id="SquadPromotionRelegationStory.Stable.subtitle"
            defaultMessage="Better luck next time!"
          />
        </LabelM>
      }
      content={
        <Root>
          <SquadImage src={story.squad.logo?.pictureUrl} alt="" />
          <DivisionBadge src={story.newDivision?.badgeUrl} alt="" />
        </Root>
      }
      cta={
        <Button
          onClick={onDismiss}
          color="secondary"
          size="medium"
          fullWidth={isMobile}
        >
          <FormattedMessage {...glossary.continue} />
        </Button>
      }
    />
  );
};
Stable.fragments = {
  footballRivalsSquadPromotionRelegationStory: gql`
    fragment Stable_footballRivalsSquadPromotionRelegationStory on FootballRivalsSquadPromotionRelegationStory {
      id
      ranking
      newDivision {
        id
        badgeUrl
      }
      squad {
        slug
        logo {
          id
          pictureUrl
        }
      }
    }
  ` as TypedDocumentNode<Stable_footballRivalsSquadPromotionRelegationStory>,
};
